'use strict';

/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * A utility type to assert that a given object is a fragment of a specific type.
 */ /**
 * Type-guard function to check if a given object is a fragment of a specific type.
 * @param data The object to check.
 * @param typename The expected typename of the fragment. Can be a string or an array of strings.
 */ const isTypedFragment = (data, typename)=>{
    if (!data && typeof data !== 'object') return false;
    if (Array.isArray(typename)) {
        return typename.includes(data == null ? void 0 : data.__typename);
    }
    return (data == null ? void 0 : data.__typename) === typename;
};
/**
 * Utility to assert that a given object is a fragment of a specific type or null.
 * @param data The object to check.
 * @param typename The expected typename of the fragment. Can be a string or an array of strings.
 * @returns The object as a fragment of the specified type, or null if it is not.
 * @see isTypedFragment
 */ const asTypedFragmentOrNull = (data, typename)=>{
    return isTypedFragment(data, typename) ? data : null;
};
/**
 *
 */ const asTypedFragmentArray = (data, typename)=>{
    if (!Array.isArray(data)) {
        return [];
    }
    return data.filter((item)=>isTypedFragment(item, typename));
};

exports.asTypedFragmentArray = asTypedFragmentArray;
exports.asTypedFragmentOrNull = asTypedFragmentOrNull;
exports.isTypedFragment = isTypedFragment;
